import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'test',
    title: 'DB Unified Training Test Portal',
    loadChildren: () =>
      import('./test-portal/test-portal.module').then(
        (m) => m.TestPortalModule
      ),
  },
  { path: '', pathMatch: 'full', redirectTo: 'test' },
  { path: '**', redirectTo: '/test' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
